import * as React from "react";
import {Route, Redirect} from "react-router-dom";
import {connect} from "react-redux";
import Page404 from "../Pages/page404";
import {validateSession} from "../utils";

const PrivateRoute = ({component: Component, ...rest}) => {
    return (
        <Route {...rest} render={props => (
            validateSession(rest.validate) ?
                <Component {...props} isEmbedded={rest.isEmbedded}/>
                : <Page404/>
        )}/>
    );
};

export default connect((src) => (src))(PrivateRoute);

